import React, { Component } from 'react';
import Modal from 'react-modal';
import { showModal, hideModal, QBM_USER_BOOKS, QBM_SEND} from '../../../modules/modals';
import {tutorialModeSelector, setTutorialMode} from '../../../modules/tutorial'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TableUsers from './components/TableUsers';
import { getUsers, createUser, deleteUser } from './actions';

class QbmUserBooks extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      users: [],
      select_email: '',
      error_message: ''
    };
  }

  async componentDidMount(){

    let res = await  getUsers();

    if(res.status){
      this.setState({
        users: res.users,
      })
    }

    
    // getUsers();
    // createUser({
    //   name: 'test',
    //   email: 'tets@gmail.com',
    // });
  }

   newItem = async (data) => {
     this.setState({error_message: ''})
    const res = await createUser(data);
    if(res.status){
      this.setState({users: [...this.state.users, res.user]})
    } else {
      this.setState({error_message: res.message});
    }    
  }
  

  deleteItem = async(id) => {

    let res = await deleteUser({id});
    this.setState({
      error_message: ''
    })
    

    if(res.status){
      this.setState({users: [...this.state.users.filter(item => item.id != id)]})
    } else {
      this.setState({
        error_message: res.message || 'User is not deleted'
      })
    }

    
  }

  selectedEmail = (select_email) => {
    this.setState({select_email}, () => {
      this.handleClose()
    })
  } 

  handleClose = () => {
    const {hideModal, qbmId, showModal, setTutorialMode, tutorialModeIsOn} = this.props;
    showModal({
      modalType : QBM_SEND,
      modalProps : {
          qbmEntity : "source",
          qbmId,
          userEmail: this.state.select_email,
          qbmCrudAction : 'create',
          okCb : (value) => {
              console.log(value)
          }
      }
    });
    hideModal({ modalType : QBM_USER_BOOKS});
    if (tutorialModeIsOn) {
      setTutorialMode(false)
    }
    
  }

  render() {
    let {zIndex} = this.props;
    const {formatMessage} = this.context;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
              <TableUsers 
                users={this.state.users} 
                formatMessage={formatMessage} 
                newItem={this.newItem}
                deleteItem={this.deleteItem}
                selectedEmail={this.selectedEmail}
                error_message={this.state.error_message}
              />
          </div>
      </Modal>
    );
  }

  getTitle = () => {
    const {qbmCrudAction, qbmEntity} = this.props
    const {formatMessage} = this.context
    const Title = this.Title
    let text = "frmCaptionAddressBook"

    return <Title>{formatMessage(text)}</Title>
  }
  Title = ({children}) => (
    <div className="create-dialog-modal-content__title">{children}</div>
  )
}

export default connect(
  state => ({
      tutorialModeIsOn : tutorialModeSelector(state),
  }),
  dispatch => ({
      hideModal : (...args) => dispatch(hideModal(...args)),
      showModal : (...args) => dispatch(showModal(...args)),
      resetForm : (form) => () => dispatch(reset(form)),
      setTutorialMode : (...args) => dispatch(setTutorialMode(...args)),
  })
)(QbmUserBooks)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmUserBooks/index.js